<template>
  <div>
    <BlockUI v-if="loading" message="Loading">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <v-card>
      <v-toolbar dense class="elevation-0">
        <v-toolbar-title>New {{ $options.moduleName }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="gotoList">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="valid" ref="qform">
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                required
                :rules="[v => !!v || 'Name is required']"
                label="Name"
                v-model="instance.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-select return-object required :rules="[v => !!v || 'Customer is required']"
                :items="customerItems"
                v-model="instance.customer"
                label="Customer"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <n-chip-date-picker
                v-model="instance.bookDate"
                :error="!instance.bookDate"
                :required="true"
                label="Date"></n-chip-date-picker>
            </v-flex>
            <v-flex xs12 md12>
              <label>Remark</label>
              <vue-editor v-model="instance.remark"></vue-editor>
            </v-flex>
            <v-flex xs12 md12>
              <items-data-table v-model="instance.items" :is-disabled="false" :vat-included="true"></items-data-table>
            </v-flex>
          </v-layout>
        </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pl-3 pr-3">
        <v-btn class="grey darken-2 white--text" @click.native="gotoList">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn outline color="green" @click.native="save" :disabled="!valid" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import swal from 'sweetalert2'
import ItemsDataTable from '@/components/item/ItemList'
import NChipDatePicker from '@/components/date-picker/NChipDatePicker'

export default {
  name: 'QuotationAdd',
  moduleName: 'Quotation',
  components: { VueEditor, NChipDatePicker, ItemsDataTable },
  data () {
    return {
      loading: false,
      valid: false,
      customerItems: [],
      instance: {
        items: []
      }
    }
  },
  methods: {
    init () {
      this.loading = true
      this.$store.dispatch('customer/loadCustomerItems')
      .then((response) => {
        this.loading = false
        this.customerItems = response.data
      }).catch(error => {
        this.loading = false
        this.$snotify.error(`${error.response.data.error}:${error.response.data.message}`, 'Fail loadCustomerItems!')
      })
    },
    gotoList () {
      this.$router.push('/quotations/list')
    },
    save () {
      if (this.$refs.qform.validate() && this.instance.bookDate) {
        this.loading = true
        this.$store.dispatch('quotation/create', this.instance)
          .then((response) => {
            this.loading = false
            this.$snotify.success(`Complete ${this.$options.moduleName}.`, 'Success!')
            this.$router.push(`/quotations/${response.data.id}`)
          }).catch(error => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/quotations/add.vue